import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { useState } from 'react'
import {
    logoutMinecardsSession,
    notifySessionChanged,
} from 'shared/api/sessionAuth'
import { Button } from 'shared/ui/Button'
import { ColorEnum } from 'shared/ui/Button/ui/Button'
import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextWeight } from 'shared/ui/Text/Text'
import { EmailAuthFlow } from './EmailAuthFlow'
import styles from './AccountAccessDialog.module.scss'

export const AccountAccessDialog = ({
    linked = false,
    onAccountChanged,
    onClose,
    onLinked,
    open = true,
}) => {
    const [screen, setScreen] = useState('actions')
    const [hasLinkedAccount, setHasLinkedAccount] = useState(linked)
    const [status, setStatus] = useState('idle')
    const [error, setError] = useState('')
    const user = getAuth(app).currentUser

    const finishAccountChange = (result) => {
        onClose()
        onAccountChanged?.(result)
    }

    const logout = async () => {
        setStatus('working')
        setError('')
        try {
            await logoutMinecardsSession()
            notifySessionChanged()
            finishAccountChange({ loggedOut: true })
        } catch (logoutError) {
            console.error('MineCards logout failed', logoutError)
            setError('Не получилось выйти. Попробуй ещё раз.')
            setStatus('idle')
        }
    }

    if (screen === 'login') {
        return (
            <BottomSheet
                label="Войти в аккаунт"
                onOpenChange={(open) => !open && setScreen('actions')}
                open={open}
            >
                <EmailAuthFlow
                    mode="login"
                    onBack={() => setScreen('actions')}
                    onComplete={finishAccountChange}
                />
            </BottomSheet>
        )
    }

    if (screen === 'link') {
        return (
            <BottomSheet
                label="Привязать почту"
                onOpenChange={(open) => !open && setScreen('actions')}
                open={open}
            >
                <EmailAuthFlow
                    mode="link"
                    onBack={() => setScreen('actions')}
                    onComplete={(result) => {
                        setHasLinkedAccount(true)
                        onLinked?.(result)
                        setScreen('actions')
                    }}
                    user={user}
                />
            </BottomSheet>
        )
    }

    return (
        <BottomSheet
            label="Аккаунт"
            onOpenChange={(open) => !open && onClose()}
            open={open}
        >
            <div className={styles.actions}>
                <Text
                    align={TextAlign.LEFT}
                    className={styles.title}
                    weight={TextWeight.BOLD}
                >
                    Аккаунт
                </Text>
                <Text align={TextAlign.LEFT} className={styles.description}>
                    {hasLinkedAccount
                        ? 'Можно войти в другой аккаунт или выйти из текущего.'
                        : 'Этот профиль не привязан к почте. После выхода вернуться к нему не получится.'}
                </Text>
                {!hasLinkedAccount && (
                    <Button
                        className={styles.primaryButton}
                        onClick={() => setScreen('link')}
                        text="Сначала привязать почту"
                    />
                )}
                <Button
                    className={styles.primaryButton}
                    color={ColorEnum.BLUE}
                    onClick={() => setScreen('login')}
                    text={
                        hasLinkedAccount
                            ? 'Войти в другой аккаунт'
                            : 'Всё равно сменить аккаунт'
                    }
                />
                <button
                    className={styles.logoutButton}
                    disabled={status === 'working'}
                    onClick={logout}
                    type="button"
                >
                    {status === 'working' ? 'Выходим…' : 'Выйти из аккаунта'}
                </button>
                {error && (
                    <p className={styles.error} role="alert">
                        {error}
                    </p>
                )}
            </div>
        </BottomSheet>
    )
}
